export interface IData {
    startLat: string,
    startLng: string,
    startText: string,
    endLat: string,
    endLng: string,
    endText: string,
    color: string,
    pickupDateTime: string,
    arrivalDateTime: string
}